<template>
  <div class="addStencil">
    <div class="til">
      <FSpanTil title="模版列表" fontSize="20">综合展现
        <FBtn @click="getAddStencli()" :type="2">新增大屏</FBtn>
      </FSpanTil>
    </div>
    <div class="fication">
      <div class="customize">
        <el-radio v-model="classType" :label="0" @change="getCheckType">自定义分辨率</el-radio>
        <div class="radio01">
          <el-input v-model="customize.width" :disabled="classType!==0"></el-input>
          <div class="svgDiv" :class="{addSvgDiv:classType!==0}">
            <FSvg title="乘"></FSvg>
          </div>
          <el-input v-model="customize.height" :disabled="classType!==0"></el-input>
        </div>
      </div>
      <div class="stencil">
        <el-radio v-model="classType" :label="1" @change="getCheckType">模版选择</el-radio>
        <div class="radio02">
          <div class="btnType">
            <FBtn :type="checkReso.index===index?2:1" :disabled="classType===0" @click="getStencilBtn(index)" v-for="(item,index) in stencil.checkList">
              {{item.x+'*'+item.y}}
            </FBtn>
          </div>
          <div class="modelDiv">
            <div class="modelDiv_left">
              <div class="dp_forList" :class="{active_dp_forList:classType===1&&checkModel.index===index
                                 ,dp_forList_hover:classType===1
                                ,no_dp_forList:classType===0}" v-for="(item,index) in checkReso.child" @click="getStencilModule(index,1)">
                <div class="dp_div">
                  <img :src="item.thumbNail" ondragstart="return false" @error="imgError">
                  <div class="div_count">
                    <div class="div_til">
                      <span>{{item.screenName}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modelDiv_cen"></div>
            <div class="modelDiv_rig">
              <!--                            <p>{{checkModel.til}}</p>-->
              <div>
                <div class="dp_forList" :class="{no_dp_forList:classType===0}" v-for="item in checkModel.child">
                  <div class="dp_div">
                    <img :src="item.thumbNail" ondragstart="return false" @error="imgError">
                    <div class="div_count">
                      <div class="div_til">
                        <span>{{item.screenName}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 @author xiaoye
 @date 2020/4/10 3:00 下午
 */


import {
  CreateNewScreen,
  GetModelIDBySize,
  GetScreenNameVerify
} from '@/assets/axios/createScreen/addStencil'

export default {
  name: 'addStencil',
  components: {},
  props: {},
  data() {
    return {
      //类型 0 自定义 1 模版
      classType: 0,
      //自定义
      customize: {
        width: '',
        height: '',
      },
      //模版
      stencil: {
        checkList: [],
      },
      //选择当前分辨率
      checkReso: {
        //分辨率索引
        index: null,
        child: [],
      },
      //选择的当前模版
      checkModel: {
        //模版索引
        index: null,
        //模版名称
        til: '',
        //模版ID
        groupID: '',
        child: [],
      },
    }
  },
  methods: {
    init() {
      //获取当前模版
      this.getModuleList();
    },
    //切换类型
    getCheckType() {

    },
    //图片加载失败
    imgError(event) {
      let index = this.randomNum(0, 2).toFixed(0);
      $(event.target).attr('src', require(`./img/dp0${index}.jpg`))
    },
    //模版选择 切换分辨率
    async getStencilBtn(index) {
      if (index === this.checkReso.index) {
        return;
      }
      this.checkReso.index = index;
      this.checkReso.child = this.stencil.checkList[index].child;
      this.checkModel = {
        index: null,
        //模版名称
        til: '',
        child: [],
        groupID: '',
      };
      await this.getStencilModule(0);
    },
    //切换模版 type 1 点击模版触发
    getStencilModule(index, type) {
      if (type === 1 && this.classType === 0) {
        return;
      }

      this.checkModel.index = index;
      this.checkModel.groupID = this.checkReso.child[index].groupID;
      this.checkModel.til = this.checkReso.child[index].screenName;
      this.checkModel.child = this.checkReso.child[index].child;
    },
    //新增模版
    getAddStencli() {
      if (this.classType === 0) {
        if (this.isNull(this.customize.width) || this.isNull(this.customize.height)) {
          return this.getMsg('请完善所选择参数！', 'info')
        }
        if (!(/^[0-9]*$/g.test(this.customize.width))) {
          return this.getMsg('请填写数字！', 'info')
        }
        if (!(/^[0-9]*$/g.test(this.customize.height))) {
          return this.getMsg('请填写数字！', 'info')
        }
      } else if (this.classType === 1) {
        if (!this.checkModel.groupID) {
          return this.getMsg('请选择模版！', 'info')
        }
      }
      this.$prompt('模版名称', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnPressEscape: false,
        closeOnClickModal: false,
        customClass: 'alert_allCom',
        beforeClose: async (action, instance, done) => {
          if (action === 'confirm') {
            if (!instance.inputValue) {
              this.getMsg('请输入模版名称');
            } else {
              if (await this.getNameRepeat(instance.inputValue)) {
                done();
              }
            }
            return false;
          } else {
            done();
          }
        }
      }).then(({ value }) => {
        this.getSave(value);
      }).catch(() => {

      });
    },
    //模版名称重复校验
    async getNameRepeat(name) {
      let bool = false;
      await GetScreenNameVerify({
        screenName: name,
      }).then(res => {
        if (res.code === 200) {
          bool = true;
        }
      }).catch(() => {

      });
      return bool;
    },
    //保存新增
    getSave(name) {
      let data = {};
      //0 自定义 1 模版
      if (this.classType === 0) {
        data = {
          type: 0,
          sizeX: this.customize.width,
          sizeY: this.customize.height,
          ScreenName: name
        };
      } else if (this.classType === 1) {
        data = {
          type: 1,
          modelID: this.checkModel.groupID,
          ScreenName: name
        };
      }
      CreateNewScreen(data).then(res => {
        if (res.code === 200) {
          this.getMsg('新增成功', 'success');
          this.setSession({
            //模版
            screen_module_xy: res.data,
            //某一块大屏
            screen_viewDp_xy: '',
          });
          this.getRouterPath('/viewScreen');
        }
      })
    },
    //获取当前模版
    getModuleList() {
      GetModelIDBySize().then(res => {
        if (res.code === 200) {
          this.stencil.checkList = res.data;
          if (this.stencil.checkList.length > 7) {
            this.stencil.checkList.length = 7;
          }
          for (let i of this.stencil.checkList) {
            i.child.map((item, index) => {
              i.child[index]['thumbNail'] = item.child[0].thumbNail || '';
            })
          }
          this.getStencilBtn(0);
        }
      }).catch(() => {

      })
    }
  },
  mounted() {
    this.init();
  },
  destroyed() {

  }
}
</script>

<style lang="less">
@borderRadio: 5px;
@borderColor: #ccc;
@shadow: 0 0 10px @h_top_backColor;
@axtive_shadow: 0 0 15px #cb0000;
//大屏一行展示多少条
@dp_size: 4;

.addStencil {
  overflow: auto;

  .til {
    line-height: 30px;
    position: relative;
    display: inline-block;
    width: 100%;

    .FSpanTil {
      vertical-align: middle;
      float: left;
    }

    .FBtn {
      margin-left: 400px;
    }
  }

  .fication {
    width: 100%;
    padding: 5px 10px;
    height: calc(100% - 70px);
    overflow-y: auto;
    overflow-x: hidden;

    .customize {
      width: 100%;
      line-height: 40px;
      display: inline-block;

      .radio01 {
        display: inline-block;

        .el-input {
          float: left;
          display: inline-block;
          width: 100px;

          .el-input__inner {
            height: 35px;
            line-height: 35px;
          }
        }

        .svgDiv {
          width: 40px;
          display: inline-block;
          float: left;
          text-align: center;

          svg {
            fill: #333 !important;
          }
        }

        .addSvgDiv {
          svg {
            fill: #ddd !important;
          }
        }
      }
    }

    .stencil {
      width: 100%;
      height: calc(100% - 60px);

      .radio02 {
        display: inline-block;
        width: 100%;
        margin-top: 15px;
        height: calc(100% - 50px);

        .btnType {
          width: calc(100% + 10px);
          max-height: 200px;

          .FBtn {
            margin-bottom: 10px;
            margin-left: 0;
            margin-right: 10px;
          }
        }

        .modelDiv {
          width: calc(100% + 30px);
          margin-left: -15px;
          height: calc(100% - 40px);
          display: inline-block;
          padding: 15px;

          .modelDiv_left {
            margin-right: 1%;
            float: left;
            height: 100%;
            width: 64%;

            .active_dp_forList {
              box-shadow: @axtive_shadow !important;
            }

            .dp_forList_hover:hover {
              box-shadow: @shadow;
            }
          }

          .modelDiv_cen {
            height: 100%;
            display: inline-block;
            width: 1px;
            border: 1px solid #eee;
            float: left;
            margin-right: 1%;
          }

          .modelDiv_rig {
            float: left;
            width: calc(34% - 2%);
            height: 100%;
            border-radius: @borderRadio;

            > p {
              width: 100%;
              font-size: 15px;
              letter-spacing: 3px;
              line-height: 35px;
              height: 35px;
              .text_oneLine;
              margin-bottom: 5px;
              border-radius: @borderRadio;
              border-bottom-left-radius: 0;
              border-bottom-right-radius: 0;
            }

            .dp_forList {
              width: 200px;
              padding-bottom: calc(200px * 0.55);

              .div_til {
                height: 25px !important;
                line-height: 25px !important;
                font-size: 12px !important;
              }
            }
          }

          .no_dp_forList {
            -webkit-filter: grayscale(100%);
            -moz-filter: grayscale(100%);
            -o-filter: grayscale(100%);
            filter: grayscale(100%);
          }

          .dp_forList {
            width: 275px;
            float: left;
            position: relative;
            padding-bottom: calc(275px * 0.55);
            border-radius: @borderRadio;
            margin-right: 15px;
            margin-bottom: 15px;

            .dp_div {
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              overflow: hidden;
              border-radius: @borderRadio;
              cursor: pointer;

              > img {
                width: 100%;
                position: absolute;
                top: 0;
                left: 0;
                z-index: 1;
              }

              > .div_count {
                width: 100%;
                height: 100%;
                position: absolute;
                top: 0;
                left: 0;
                z-index: 2;

                > .div_til {
                  width: 100%;
                  border-top-right-radius: @borderRadio;
                  border-top-left-radius: @borderRadio;
                  background-color: hsl(@green, 70%);
                  height: 30px;
                  min-height: 20px;
                  padding: 0 3%;
                  font-size: 14px;
                  letter-spacing: 1px;
                  position: relative;

                  > span {
                    display: inline-block;
                    max-width: 70%;
                    float: left;
                    color: #fff;
                    .com_middle;
                    .text_oneLine;
                  }

                  > div {
                    width: 18px;
                    height: 18px;
                    float: right;
                    display: inline-block;
                    margin-right: 10px;
                    .com_middle;
                    margin-top: -2px;
                  }
                }
              }
            }
          }
        }
      }
    }

    .el-radio {
      float: left;
      line-height: 40px;

      .el-radio__input {
        margin-top: -2px;
      }

      .el-radio__inner {
        width: 18px;
        height: 18px;
      }

      .el-radio__label {
        font-size: 18px;
      }

      .el-radio__inner::after {
        width: 6px;
        height: 6px;
      }
    }
  }
}
</style>